import useSWR, { SWRConfiguration } from "swr";
import { IEirSalesViewAvailableAppointments } from "../interfaces/models/IEirSalesViewAvailableAppointments";
import { getViewAvailableAppointments } from "../apis/getViewAvailableAppointments";

export const useViewAvailableAppointments = (
    prospectReference: string,
    offerId: number,
    canFetch: boolean,
    options: SWRConfiguration = {}
) =>
    useSWR<IEirSalesViewAvailableAppointments>(
        canFetch ? ["useViewAvailableAppointments", prospectReference, offerId] : null,
        {
            ...options,
            fetcher: () => getViewAvailableAppointments(prospectReference!, offerId),
        }
    );
